export default {
	bindClickHooks: function () {
		// pp.log("HOOKS:", window.jQuery('.j-vue-hook-click'));
		window
			.jQuery(document)
			.off("click", ".j-vue-hook-click", this.handleVueHookClick);
		window
			.jQuery(document)
			.on("click", ".j-vue-hook-click", this.handleVueHookClick);
	},

	handleVueHookClick: function (e) {
		e.preventDefault();
		e.stopPropagation();
		const vueHookData = window.jQuery(e.currentTarget).data("vue-hook-data");
		pp.log("EMITTING HOOK -- data", vueHookData);
		pp.vue.bus.$emit("vue-hook:" + vueHookData.channel, vueHookData.data);
	},
};
